"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockLocaleServiceUtil = void 0;
const LocaleService_1 = require("./LocaleService");
const MockLocaleServiceInitParamsUtil_1 = require("./MockLocaleServiceInitParamsUtil");
class MockLocaleServiceUtil {
    static initLocaleServiceMetric() {
        if (LocaleService_1.LocaleService.hasBeenInitialized()) {
            return LocaleService_1.LocaleService.update(MockLocaleServiceInitParamsUtil_1.MockLocaleServiceInitParamsUtil.getMockLocaleServiceInitParamsDeWithoutISales());
        }
        return LocaleService_1.LocaleService.init(MockLocaleServiceInitParamsUtil_1.MockLocaleServiceInitParamsUtil.getMockLocaleServiceInitParamsDeWithoutISales() // use DE for metric
        );
    }
    static initLocaleServiceImperial() {
        if (LocaleService_1.LocaleService.hasBeenInitialized()) {
            return LocaleService_1.LocaleService.update(MockLocaleServiceInitParamsUtil_1.MockLocaleServiceInitParamsUtil.getMockLocaleServiceInitParamsUsWithoutISales());
        }
        return LocaleService_1.LocaleService.init(MockLocaleServiceInitParamsUtil_1.MockLocaleServiceInitParamsUtil.getMockLocaleServiceInitParamsUsWithoutISales() // use US for imperial
        );
    }
    static reset() {
        LocaleService_1.LocaleService.reset();
    }
}
exports.MockLocaleServiceUtil = MockLocaleServiceUtil;
//# sourceMappingURL=MockLocaleServiceUtil.js.map